import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Toaster } from "../ui/sonner";
import { MatrixCursor } from "../effects/MatrixCursor";

export const SiteLayout = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen overflow-x-hidden bg-[#0a0a0c] text-white">
      <div className="rm-noise" aria-hidden="true" />
      <MatrixCursor />
      <Header />
      <main className="relative z-10 pt-20">
        <Outlet />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121216",
            color: "#f8f8f8",
            border: "1px solid #27272a",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
};
